/* ============================================================
   RACK MODAL DEVIS — JavaScript (multi-step 4 étapes)
   - Step 1 : Type rack | Step 2 : Surface | Step 3 : Délai | Step 4 : Coordonnées
   - Auto-advance entre steps quand radio sélectionné
   - Quick form shortcut "Pressé ? Email + tél"
   - Téléphone international avec normalisation E.164
   - Mobile sticky CTA trigger
   - Endpoint Make partagé avec gondoles → routing par lead_type + page_url + utm
   ============================================================ */

(function() {
  'use strict';

  const modal = document.getElementById('modal-devis');
  if (!modal) return;

  const form = modal.querySelector('#devis-form');
  const steps = Array.from(modal.querySelectorAll('.modal-step'));
  const progressFill = modal.querySelector('[data-progress-fill]');
  const progressCurrent = modal.querySelector('[data-step-current]');
  const btnBack = modal.querySelector('[data-step-back]');
  const btnNext = modal.querySelector('[data-step-next]');
  const btnSubmit = modal.querySelector('[data-step-submit]');
  const navFooter = modal.querySelector('[data-nav-footer]');
  const shortcutWrap = modal.querySelector('[data-shortcut-wrap]');
  const quickWrap = modal.querySelector('[data-quick]');
  const quickForm = modal.querySelector('#devis-quick-form');

  const TOTAL_STEPS = 4;
  let currentStep = 1;
  let submitted = false;

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('inert');
    document.body.classList.add('modal-open');
    goToStep(1);
    closeQuick();
    setTimeout(() => {
      const firstInput = steps[0].querySelector('input');
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 200);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');
    document.body.classList.remove('modal-open');
    setTimeout(() => {
      form.reset();
      if (quickForm) quickForm.reset();
      closeQuick();
      goToStep(1);
    }, 300);
  }

  function goToStep(n) {
    currentStep = n;
    steps.forEach(s => s.classList.remove('is-active'));
    const target = modal.querySelector(`[data-step="${n}"]`);
    if (target) target.classList.add('is-active');

    if (typeof n === 'number') {
      const pct = (n / TOTAL_STEPS) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressCurrent) progressCurrent.textContent = n;
      navFooter.removeAttribute('data-hidden');
      if (shortcutWrap) shortcutWrap.removeAttribute('data-hidden');

      if (n === 1) btnBack.setAttribute('data-hidden', '');
      else btnBack.removeAttribute('data-hidden');

      if (n === TOTAL_STEPS) {
        btnNext.setAttribute('data-hidden', '');
        btnSubmit.removeAttribute('data-hidden');
      } else {
        btnNext.removeAttribute('data-hidden');
        btnSubmit.setAttribute('data-hidden', '');
      }
    } else {
      // success
      navFooter.setAttribute('data-hidden', '');
      if (shortcutWrap) shortcutWrap.setAttribute('data-hidden', '');
      if (progressFill) progressFill.style.width = '100%';
    }
    if (form) form.scrollTop = 0;
  }

  function validateCurrentStep() {
    const target = modal.querySelector(`[data-step="${currentStep}"]`);
    if (!target) return false;

    if (currentStep <= 3) {
      const radios = target.querySelectorAll('input[type="radio"]');
      const checked = Array.from(radios).some(r => r.checked);
      if (!checked) {
        target.classList.add('shake');
        setTimeout(() => target.classList.remove('shake'), 400);
        return false;
      }
      return true;
    }
    if (currentStep === 4) {
      const requiredInputs = target.querySelectorAll('input[required]');
      let valid = true;
      requiredInputs.forEach(input => {
        if (!input.value.trim() || !input.checkValidity()) {
          input.reportValidity();
          valid = false;
        }
      });
      return valid;
    }
    return true;
  }

  // --- QUICK FORM (shortcut "Pressé ? Email + tél") ---
  function openQuick() {
    if (!quickWrap) return;
    quickWrap.hidden = false;
    setTimeout(() => {
      const input = quickWrap.querySelector('input');
      if (input) input.focus({ preventScroll: true });
    }, 100);
  }
  function closeQuick() {
    if (quickWrap) quickWrap.hidden = true;
  }

  // --- EVENTS ---
  document.addEventListener('click', function(e) {
    const opener = e.target.closest('[data-open-modal="devis"], a[href="#devis"]');
    if (opener) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('[data-close-modal]')) {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.target.closest('[data-shortcut-open]')) {
      e.preventDefault();
      openQuick();
      return;
    }
    if (e.target.closest('[data-quick-close]')) {
      e.preventDefault();
      closeQuick();
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (modal.getAttribute('aria-hidden') === 'false') {
      if (quickWrap && !quickWrap.hidden) closeQuick();
      else closeModal();
    }
  });

  btnNext.addEventListener('click', function() {
    if (!validateCurrentStep()) return;
    if (currentStep < TOTAL_STEPS) goToStep(currentStep + 1);
  });

  btnBack.addEventListener('click', function() {
    if (currentStep > 1) goToStep(currentStep - 1);
  });

  // Auto-advance steps 1-3 quand radio sélectionné
  modal.querySelectorAll('#devis-form input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      if (currentStep <= 3) {
        setTimeout(() => {
          if (currentStep <= 3) goToStep(currentStep + 1);
        }, 280);
      }
    });
  });

  // --- PHONE NORMALIZATION & VALIDATION ---
  function normalizePhone(number, dial) {
    if (!number) return '';
    let cleaned = number.replace(/[^\d+]/g, '');
    if (cleaned.charAt(0) === '+') return cleaned;
    if (cleaned.substring(0, 2) === '00') return '+' + cleaned.substring(2);
    if (!dial) return cleaned ? '+' + cleaned : '';
    if (cleaned.charAt(0) === '0') cleaned = cleaned.substring(1);
    return dial + cleaned;
  }

  function validatePhone(number, expectedLengths) {
    if (!number) return false;
    const digitsOnly = number.replace(/[^\d]/g, '');
    const national = digitsOnly.charAt(0) === '0' ? digitsOnly.substring(1) : digitsOnly;
    return expectedLengths.indexOf(national.length) !== -1;
  }

  function setupPhoneField(wrapperEl) {
    if (!wrapperEl) return;
    const select = wrapperEl.querySelector('[data-phone-country]');
    const input = wrapperEl.querySelector('[data-phone-input]');
    if (!select || !input) return;
    function getExpectedLengths() {
      const opt = select.options[select.selectedIndex];
      const raw = (opt.getAttribute('data-lengths') || '').split(',');
      return raw.map(function(n) { return parseInt(n.trim(), 10); }).filter(function(n) { return !isNaN(n); });
    }
    function check() {
      const val = input.value.trim();
      const lengths = getExpectedLengths();
      const valid = val && validatePhone(val, lengths);
      wrapperEl.setAttribute('data-phone-state', valid ? 'valid' : '');
    }
    input.addEventListener('input', check);
    select.addEventListener('change', check);
    check();
  }
  document.querySelectorAll('.modal-field-phone').forEach(setupPhoneField);

  function getNormalizedPhoneFromForm(formEl) {
    if (!formEl) return { e164: '', raw: '', country: '' };
    const phoneGroup = formEl.querySelector('.modal-field-phone');
    if (!phoneGroup) return { e164: '', raw: '', country: '' };
    const select = phoneGroup.querySelector('[data-phone-country]');
    const input = phoneGroup.querySelector('[data-phone-input]');
    if (!select || !input || !input.value) return { e164: '', raw: '', country: select ? select.value : '' };
    const opt = select.options[select.selectedIndex];
    const dial = opt.getAttribute('data-dial') || '';
    return {
      e164: normalizePhone(input.value, dial),
      raw: input.value,
      country: select.value
    };
  }

  // --- SUBMITS ---
  function handleSubmission(data, source, formEl) {
    submitted = true;
    const phone = getNormalizedPhoneFromForm(formEl);
    const emailValue = (data.email || '').trim();
    const emailDomain = emailValue.indexOf('@') > -1
      ? emailValue.split('@')[1].toLowerCase()
      : '';

    const payload = {
      source: source,
      lead_type: 'rack-industriel',
      submitted_at: new Date().toISOString(),
      page_url: window.location.href,
      prenom: data.prenom || '',
      nom: data.nom || '',
      email: emailValue,
      email_domain: emailDomain,
      telephone: phone.e164,
      telephone_raw: phone.raw,
      telephone_country: phone.country,
      entreprise: data.entreprise || '',
      message: data.message || '',
      type_rack: data.typeRack || '',
      surface: data.surface || '',
      delai: data.delai || '',
      utm_source: new URLSearchParams(window.location.search).get('utm_source') || 'direct',
      utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign') || '',
      utm_term: new URLSearchParams(window.location.search).get('utm_term') || '',
      utm_medium: new URLSearchParams(window.location.search).get('utm_medium') || ''
    };
    if (window.saLeadAttribution) { try { Object.assign(payload, window.saLeadAttribution()); } catch (e) {} }

    (window.saSendLead ? window.saSendLead(payload) : fetch('https://hook.eu1.make.com/2e2wlyctys7jr5ggqpx4eiqqqaj2qh9d', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })).catch(function(err) {
      console.error('[devis-rack] webhook error:', err);
    });

    console.log('[devis-rack] lead submitted:', payload);
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!validateCurrentStep()) return;
    const data = Object.fromEntries(new FormData(form).entries());
    handleSubmission(data, 'full', form);
    goToStep('success');
  });

  if (quickForm) {
    quickForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const data = Object.fromEntries(new FormData(quickForm).entries());
      handleSubmission(data, 'quick', quickForm);
      closeQuick();
      goToStep('success');
    });
  }

})();
